import React from "react";

const DeleteTrashIcon = ({
  height = 16,
  width = 16,
  color = "none",
  className = "",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    className={className}
  >
    <path
      d="M9.6 6.40078V12.0008M6.4 6.40078V12.0008M3.2 3.20078V12.6408C3.2 13.5369 3.2 13.9846 3.37439 14.3269C3.52779 14.6279 3.77238 14.8732 4.07344 15.0266C4.41536 15.2008 4.8632 15.2008 5.75753 15.2008H10.2425C11.1368 15.2008 11.584 15.2008 11.9259 15.0266C12.227 14.8732 12.4724 14.6279 12.6258 14.3269C12.8 13.9849 12.8 13.5376 12.8 12.6433V3.20078M3.2 3.20078H4.8M3.2 3.20078H1.6M4.8 3.20078H11.2M4.8 3.20078C4.8 2.45527 4.8 2.08271 4.9218 1.78867C5.08419 1.39663 5.39546 1.08496 5.7875 0.922574C6.08154 0.800781 6.4545 0.800781 7.2 0.800781H8.8C9.54551 0.800781 9.91826 0.800781 10.2123 0.922574C10.6043 1.08496 10.9157 1.39663 11.0781 1.78867C11.1999 2.08271 11.2 2.45528 11.2 3.20078M11.2 3.20078H12.8M12.8 3.20078H14.4"
      stroke="currentColor"
      stroke-width="1.6"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export default DeleteTrashIcon;
